function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { useMenu } from 'react-instantsearch';
import { Button as RKSButton, FormRadioButtons } from '@uncinc/uncinc-react-kitchen-sink';
import { DEFAULT_TEXT } from '../../../config/constants';
const SearchFacetMenuRadios = props => {
  const {
    t
  } = useTranslation();
  const {
    attribute,
    showMore,
    showMoreButton,
    showMoreText = t(['searchkit.buttons.show_more', DEFAULT_TEXT.BUTTONS.SHOW_MORE]),
    showLessText = t(['searchkit.buttons.show_less', DEFAULT_TEXT.BUTTONS.SHOW_LESS]),
    className,
    itemClassName,
    ...restProps
  } = props;
  const {
    items,
    canToggleShowMore,
    isShowingMore,
    toggleShowMore,
    refine
  } = useMenu(props);
  const classNames = c('Searchkit__Facet__MenuRadios', className);
  const itemClassNames = c('Searchkit__Facet__MenuRadios__item', itemClassName);
  const Button = showMoreButton || RKSButton;
  const fieldName = "menu_".concat(attribute);
  const options = items.map(item => ({
    value: item.value,
    label: /*#__PURE__*/React.createElement("span", {
      className: "Searchkit__Facet__label",
      "data-facet-label": item.label,
      "data-facet-count": item.count
    }, /*#__PURE__*/React.createElement("span", {
      className: "Searchkit__Facet__label__label"
    }, item.label), /*#__PURE__*/React.createElement("span", {
      className: "Searchkit__Facet__label__count"
    }, item.count)),
    disabled: item.count === 0
  }));
  const currentOption = items.find(item => item.isRefined);
  const defaultValue = currentOption === null || currentOption === void 0 ? void 0 : currentOption.value;
  return /*#__PURE__*/React.createElement("div", {
    className: "Searchkit__Facet__MenuRadios__wrapper"
  }, /*#__PURE__*/React.createElement(FormRadioButtons, _extends({}, restProps, {
    fieldName: fieldName,
    options: options,
    defaultValue: defaultValue,
    wrapperClassName: classNames,
    className: itemClassNames,
    onChange: value => {
      refine(value);
    }
  })), showMore && canToggleShowMore && /*#__PURE__*/React.createElement(Button, {
    className: "Searchkit__Facet__MenuRadios__showMore",
    onClick: () => {
      toggleShowMore();
    }
  }, isShowingMore ? showLessText : showMoreText));
};
export default SearchFacetMenuRadios;